import { render, staticRenderFns } from "./ValueHelpWrapper.vue?vue&type=template&id=38ca0724&"
import script from "./ValueHelpWrapper.vue?vue&type=script&lang=js&"
export * from "./ValueHelpWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports